import axios from "axios";

// const Base_URL = "https://";

class BackendService {

    AzureAiV2(query, filter, skip) {
        // const Ais_endpoint = "https://ais-gittr-sbx-sca-gewc.search.windows.net";
        // const Ais_apiKey = "5L3aybTZOYpkQvxU33SfddNOvHRZq4uG7QKgL8LI9DAzSeDJqics";
        // const Ais_indexName = "vector-sca-clause-alias";
        const apiVersion = "2025-05-01-preview";

        const Ais_endpoint = "https://ais-gitba-nonprd-scaaut-gewc.search.windows.net";
        const Ais_apiKey = "RAiHrlKt1lfRKGNFN6O0OTVLHBSxODw4XedpP4AcxyAzSeDYy3iy";
        const Ais_indexName = "vector-scauat-clause-alias";
        // const apiVersion = "2025-03-01-preview";

        const input = query.searchText.trim();
        const isExactPhrase = input.startsWith('"');

        const requestBody = {
            search: isExactPhrase ? input : input, // same value, but you can handle it differently if needed
            queryType: "full", // required for phrase search
            searchMode: "all",
            skip: skip,
            top: 1000,
            count: true
        };

        if (filter) {
            requestBody.filter = filter;
        }

        try {
            const response = axios.post(`${Ais_endpoint}/indexes/${Ais_indexName}/docs/search?api-version=${apiVersion}`, requestBody, {
                headers: {
                    'Content-Type': 'application/json',
                    'api-key': Ais_apiKey,
                },
            });
            return response; // Return search results
        } catch (error) {
            console.error('Error fetching search results:', error);
            throw error; // Rethrow error for handling in the calling function
        }
    }


    FetchDropdownData() {
        // const Ais_endpoint = "https://ais-gittr-sbx-sca-gewc.search.windows.net";
        // const Ais_apiKey = "5L3aybTZOYpkQvxU33SfddNOvHRZq4uG7QKgL8LI9DAzSeDJqics";
        // const Ais_indexName = "vector-sca-clause-alias";
        const apiVersion = "2025-05-01-preview";

        const Ais_endpoint = "https://ais-gitba-nonprd-scaaut-gewc.search.windows.net";
        const Ais_apiKey = "RAiHrlKt1lfRKGNFN6O0OTVLHBSxODw4XedpP4AcxyAzSeDYy3iy";
        const Ais_indexName = "vector-scauat-clause-alias";
        // const apiVersion = "2025-03-01-preview";

        const requestBody = {
            "search": "*",
            "facets": [
                "projectId,count:1000000",
                "supplier/name,count:1000000",
                // "regions/name,count:1000000",
                // "commodities/name,count:1000000",
                "signingLegalEntity,count:1000000",
                "contractType,count:1000000",
                "paymentTerms,count:1000000",
                "parentAgreement,count:1000000",
                "stdClauses/clauseLabel,count:1000000"
            ],
            "count": true,
            "top": 0
        };


        try {
            const response = axios.post(`${Ais_endpoint}/indexes/${Ais_indexName}/docs/search?api-version=${apiVersion}`, requestBody, {
                headers: {
                    'Content-Type': 'application/json',
                    'api-key': Ais_apiKey,
                },
            });

            return response;

            // Extract unique regions and suppliers using Set

        } catch (error) {
            console.error('Error fetching search results:', error);
            throw error; // Rethrow error for handling in the calling function
        }
    }

    FetchRegionsDropdownData() {
        const Ais_endpoint = "https://ais-gittr-sbx-sca-gewc.search.windows.net";
        const Ais_apiKey = "5L3aybTZOYpkQvxU33SfddNOvHRZq4uG7QKgL8LI9DAzSeDJqics";
        const Ais_indexName = "index-region-master";
        const apiVersion = "2025-05-01-preview";

        // const Ais_endpoint = "https://ais-gitba-nonprd-scaaut-gewc.search.windows.net";
        // const Ais_apiKey = "RAiHrlKt1lfRKGNFN6O0OTVLHBSxODw4XedpP4AcxyAzSeDYy3iy";
        // const Ais_indexName = "vector-scauat-clause-alias";
        // const apiVersion = "2025-03-01-preview";

        const requestBody = {
            "search": "*",
            "facets": [
                "HierarchyPath_Description,count:10000"
            ],
            "count": true,
            "top": 0
        };


        try {
            const response = axios.post(`${Ais_endpoint}/indexes/${Ais_indexName}/docs/search?api-version=${apiVersion}`, requestBody, {
                headers: {
                    'Content-Type': 'application/json',
                    'api-key': Ais_apiKey,
                },
            });

            console.log('FetchRegionsDropdownData response:', response);

            return response;

            // Extract unique regions and suppliers using Set

        } catch (error) {
            console.error('Error fetching search results:', error);
            throw error; // Rethrow error for handling in the calling function
        }
    }

    FetchCommoditiesDropdownData() {
        const Ais_endpoint = "https://ais-gittr-sbx-sca-gewc.search.windows.net";
        const Ais_apiKey = "5L3aybTZOYpkQvxU33SfddNOvHRZq4uG7QKgL8LI9DAzSeDJqics";
        const Ais_indexName = "index-master-data";
        const apiVersion = "2025-05-01-preview";

        // const Ais_endpoint = "https://ais-gitba-nonprd-scaaut-gewc.search.windows.net";
        // const Ais_apiKey = "RAiHrlKt1lfRKGNFN6O0OTVLHBSxODw4XedpP4AcxyAzSeDYy3iy";
        // const Ais_indexName = "vector-scauat-clause-alias";
        // const apiVersion = "2025-03-01-preview";

        const requestBody = {
            "search": "*",
            "facets": [
                "HierarchyPath_Description,count:20000"
            ],
            "count": true,
            "top": 0
        };


        try {
            const response = axios.post(`${Ais_endpoint}/indexes/${Ais_indexName}/docs/search?api-version=${apiVersion}`, requestBody, {
                headers: {
                    'Content-Type': 'application/json',
                    'api-key': Ais_apiKey,
                },
            });

            console.log('FetchRegionsDropdownData response:', response);

            return response;

            // Extract unique regions and suppliers using Set

        } catch (error) {
            console.error('Error fetching search results:', error);
            throw error; // Rethrow error for handling in the calling function
        }
    }


    AzureAiV2Autocomplete(query, suggesterName) {
        // const Ais_endpoint = "https://ais-gittr-sbx-sca-gewc.search.windows.net";
        // const Ais_apiKey = "5L3aybTZOYpkQvxU33SfddNOvHRZq4uG7QKgL8LI9DAzSeDJqics";
        // const Ais_indexName = "vector-sca-clause-alias";
        const apiVersion = "2025-05-01-preview";

        const Ais_endpoint = "https://ais-gitba-nonprd-scaaut-gewc.search.windows.net";
        const Ais_apiKey = "RAiHrlKt1lfRKGNFN6O0OTVLHBSxODw4XedpP4AcxyAzSeDYy3iy";
        const Ais_indexName = "vector-scauat-clause-alias";
        // const apiVersion = "2025-03-01-preview";

        const requestBody = {
            search: query,
            suggesterName: suggesterName,
            autocompleteMode: "oneTermWithContext"
        };

        try {
            const response = axios.post(`${Ais_endpoint}/indexes/${Ais_indexName}/docs/autocomplete?api-version=${apiVersion}`, requestBody, {
                headers: {
                    'Content-Type': 'application/json',
                    'api-key': Ais_apiKey,
                },
            });
            return response; // Return autocomplete results
        } catch (error) {
            console.error('Error fetching autocomplete results:', error);
            throw error; // Rethrow error for handling in the calling function
        }
    }


    AzureAiV2Suggest(query, suggesterName) {
        // const Ais_endpoint = "https://ais-gittr-sbx-sca-gewc.search.windows.net";
        // const Ais_apiKey = "5L3aybTZOYpkQvxU33SfddNOvHRZq4uG7QKgL8LI9DAzSeDJqics";
        // const Ais_indexName = "vector-sca-clause-alias";
        const apiVersion = "2025-05-01-preview";

        const Ais_endpoint = "https://ais-gitba-nonprd-scaaut-gewc.search.windows.net";
        const Ais_apiKey = "RAiHrlKt1lfRKGNFN6O0OTVLHBSxODw4XedpP4AcxyAzSeDYy3iy";
        const Ais_indexName = "vector-scauat-clause-alias";
        // const apiVersion = "2025-03-01-preview";

        const requestBody = {
            search: query,
            suggesterName: suggesterName,
            top: 5,
        };

        try {
            const response = axios.post(`${Ais_endpoint}/indexes/${Ais_indexName}/docs/suggest?api-version=${apiVersion}`, requestBody, {
                headers: {
                    'Content-Type': 'application/json',
                    'api-key': Ais_apiKey,
                },
            });
            return response; // Return suggestion results
        } catch (error) {
            console.error('Error fetching suggestion results:', error);
            throw error; // Rethrow error for handling in the calling function
        }
    }

    FetchReportToken() {
        const endpoint = "https://api.powerbi.com/v1.0/myorg/groups/{groupId}/reports/{reportId}/GenerateToken";

        try {
            const response = axios.post(`${endpoint}`, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            return response;

            // Extract unique regions and suppliers using Set

        } catch (error) {
            console.error('Error fetching search results:', error);
            throw error; // Rethrow error for handling in the calling function
        }
    }
}

const backendService = new BackendService();

export default backendService;
